import React from 'react';
import './App.scss';
import {Header} from "./components/Header/Header";
import {Footer} from "./components/Footer/Footer";
import {Route, Routes} from "react-router-dom";
import {Home} from "./components/Home/Home";
import {Skills} from "./components/Skills/Skills";
import {Portfolio} from "./components/Portfolio/Portfolio";
import {About} from "./components/About/About";
import {Contacts} from "./components/Contacts/Contacts";

const App = () => {

    return (
    <div className="wrapper">
        <div className="intro_particles">
            <img src="./assets/images/particles/tetris/tetris1.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris2.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris3.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris4.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris5.svg" alt="" className="particle"/>
        </div>
        <div className="intro_particles">
            <img src="./assets/images/particles/tetris/tetris2.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris5.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris4.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris1.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris3.svg" alt="" className="particle"/>
        </div>
        <div className="intro_particles">
            <img src="./assets/images/particles/tetris/tetris3.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris4.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris5.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris2.svg" alt="" className="particle"/>
            <img src="./assets/images/particles/tetris/tetris1.svg" alt="" className="particle"/>
        </div>
        <Header />
        <main className="main">
            <Routes>
                <Route path={'/'} element={<Home />} />
                <Route path={'/skills'} element={<Skills />} />
                <Route path={'/portfolio'} element={<Portfolio />} />
                <Route path={'/about'} element={<About />} />
                <Route path={'/contacts'} element={<Contacts />} />
            </Routes>
        </main>
        <Footer />
    </div>
  );
}

export default App;
